export default {"src":"/_next/static/media/laptop-flawless.d5d09cca.svg","height":71,"width":113};